import { Component } from '@theme/component';
/** Enhances the map while leaving all region copy readable without JavaScript. */
class TewRegions extends Component {
  connectedCallback() { super.connectedCallback(); this.select(this.dataset.selected || this.querySelector('[data-region-panel]')?.getAttribute('data-region-panel')); }
  updatedCallback() { super.updatedCallback(); this.select(this.dataset.selected || this.querySelector('[data-region-panel]')?.getAttribute('data-region-panel')); }
  /** @param {Event} event */
  choose(event) {
    if (!(event.target instanceof Element)) return;
    const control = event.target.closest('[data-region-select]');
    if (!control) return;
    event.preventDefault();
    this.select(control.getAttribute('data-region-select'));
    if (event.type === 'click' && !control.closest('svg')) this.querySelector('[data-region-panel]:not([hidden])')?.scrollIntoView({block:'nearest'});
  }
  /** @param {PointerEvent} event */
  hover(event) { if (event.pointerType === 'mouse') this.choose(event); }
  select(key) {
    const panels = this.querySelectorAll('[data-region-panel]');
    if (![...panels].some(p => p.getAttribute('data-region-panel') === key)) return;
    this.dataset.selected = key;
    for (const panel of panels) panel.hidden = panel.getAttribute('data-region-panel') !== key;
    for (const shape of this.querySelectorAll('[data-region-shape]')) shape.classList.toggle('is-selected',shape.getAttribute('data-region-shape') === key);
    for (const control of this.querySelectorAll('[data-region-select]')) {
      if (control.getAttribute('data-region-select') === key) control.setAttribute('aria-current','true'); else control.removeAttribute('aria-current');
    }
  }
}
if (!customElements.get('tew-regions-component')) customElements.define('tew-regions-component',TewRegions);
